// Material Kit 2 React pages
import Interior from "pages/Albums/interior";

export default function InteriorPage() {
  return <Interior />;
}
